/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Boundary_Connection_LostInputs */

const nl_common_error_boundary_connection_lost = /** @type {(inputs: Common_Error_Boundary_Connection_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen verbinding. Controleer je internet en probeer het opnieuw.`)
};

/**

* @param {Common_Error_Boundary_Connection_LostInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_error_boundary_connection_lost = /** @type {((inputs?: Common_Error_Boundary_Connection_LostInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Boundary_Connection_LostInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_error_boundary_connection_lost(inputs)
});
export { common_error_boundary_connection_lost as "common.error_boundary_connection_lost" }